import { jours } from "../cadendar-consts.js";
import { z } from "zod/v4";
import { holidayZoneSchema } from "./PublicHolidays.js";
export const newPreferencesSchema = z.object({
    duree_min_rdv: z.number().int().gte(5).lte(120),
    email_expediteur: z.string().email().optional(),
    email_text: z.string().optional(),
    sms_name: z.string().optional(),
    sms_text: z.string().optional(),
    blocs_ratio: z.number().int().gte(0).lte(100).optional(),
    blocs_unlockedDays: z.number().int().gte(0).optional(),
    confirm_text: z.string().optional(),
    duree_default_rdv: z.number().int().gte(5).lte(120).optional(),
    time_division: z.number().int().gte(5).lte(60),
    holiday_zone: holidayZoneSchema.optional(),
});
export const existingPreferencesSchema = newPreferencesSchema.extend({
    id: z.string().min(2),
    owner_id: z.string().min(2),
});
const commonUserPropsSchema = z.object({
    _id: z.string(),
    username: z.string(),
    fullname: z.string().optional(),
    messagename: z.string().optional(),
    emails: z
        .array(z.object({
        address: z.string().email(),
        verified: z.boolean(),
    }))
        .optional(),
    smsname: z.string().optional(),
    services: z.object({
        password: z.object({
            bcrypt: z.string(),
        }),
        resume: z.object({
            loginTokens: z.array(z.object({
                when: z.date(),
                hashedToken: z.string(),
            })),
        }),
    }),
    active: z.boolean(),
    organization_id: z.number().int(),
});
const userTags = ["doctor", "secretary", "app"];
export const secretaryUserSchema = commonUserPropsSchema.extend({
    doctor_id: z.array(z.string()).optional(),
    tag: z.literal("secretary"),
});
export const doctorUserSchema = commonUserPropsSchema.extend({
    secretaries: z.array(z.string()).optional(),
    tag: z.literal("doctor"),
    doc_id: z.string(),
    address: z.string(),
    office_phone: z.string(),
    speciality: z.string(),
    google_business_profile_id: z.string().nullable(),
});
export const LimitedDocInfoSchema = z.object(doctorUserSchema.pick({
    fullname: true,
    address: true,
    office_phone: true,
    doc_id: true,
    speciality: true,
    google_business_profile_id: true,
}).shape);
export const adminUserSchema = commonUserPropsSchema.extend({
    username: z.literal("admin"),
});
export const userSchema = z.union([secretaryUserSchema, doctorUserSchema]);
export const appUserSchema = commonUserPropsSchema.extend({
    tag: z.literal("app"),
});
export const limitedUserSchema = z.union([
    z.object(doctorUserSchema.pick({
        _id: true,
        fullname: true,
        tag: true,
        office_phone: true,
        address: true,
        speciality: true,
    }).shape),
    z.object(secretaryUserSchema.pick({
        _id: true,
        fullname: true,
        tag: true,
    }).shape),
]);
const hmObjSchema = z.object({
    heure: z.number().int().gte(0).lte(24),
    minute: z.number().int().gte(0).lte(60),
});
const plageSchema = z.object({ start: hmObjSchema, end: hmObjSchema });
export const newHoraireSchema = z.object({
    date: z.date(),
    horaire: z.record(z.enum(jours), z.array(plageSchema)),
    format: z.number().int().gte(1),
});
export const existingHoraireSchema = newHoraireSchema.extend({
    _id: z.string().min(2),
    owner: z.string().min(2),
});
//# sourceMappingURL=Collections.js.map